import { combineReducers } from 'redux';
import governorDashboardReducer from './governorDashboardReducer';
import AuthReducer from './authenticationReducer';
import GeneralReducer from './generalReducer';
import DetailReducer from './detailsReducer';
import ClientDetailsReducer from './clientDetailsReducer';
import HomeReducer from './homeReducer';
import GlossaryReducer from './glossaryReducer';
import WhatsNewReducer from './whatsNewReducer';
import NewJoinerReducer from './newJoinerReducer';
import SearchResultsReducer from './searchResultsReducer';
import RefinerReducer from './refinerReducer';
import RecentlyViewedReducer from './recentlyViewedReducer';
import ContactReducer from './contactReducer';
import ClientContactReducer from './clientContactReducer';
import MyDataReducer from './myDataReducer';
import RequestAccessReducer from './requestAccessReducer';
import RequestAccessDPFReducer from './requestAccessDPFReducer';
import ErrorReducer from './errorReducer';
import userSearchReducer from './peopleSearchReducer';
import producerDashboardReducer from './producerDashboardReducer';
import producerListReducer from './producerListReducer';

import consumerDataProductRequestReducer from './consumerDataProductRequestReducer';
import dataProductReducer from './dataProductReducer';
import reassignProducerReducer from './reassignProducerReducer';
import productRequestDetailsReducer from './productRequestDetailsReducer';

const rootReducer = combineReducers({
  authenticationData: AuthReducer,
  generalData: GeneralReducer,
  detailData: DetailReducer,
  clientDetailData: ClientDetailsReducer,
  homeData: HomeReducer,
  glossaryData: GlossaryReducer,
  whatsNewData: WhatsNewReducer,
  newJoinerData: NewJoinerReducer,
  searchResultData: SearchResultsReducer,
  refinerData: RefinerReducer,
  recentlyViewedData: RecentlyViewedReducer,
  contactData: ContactReducer,
  clientContactdata: ClientContactReducer,
  myData: MyDataReducer,
  requestAccessData: RequestAccessReducer,
  requestAccessDPFData: RequestAccessDPFReducer,
  errorData: ErrorReducer,
  userSearchData: userSearchReducer,
  governorData: governorDashboardReducer,
  producerData: producerDashboardReducer,
  producerListData: producerListReducer,
  reassignProducerData: reassignProducerReducer,
  consumerDataProductRequestData: consumerDataProductRequestReducer,
  dataProduct: dataProductReducer,
  productRequestDetails: productRequestDetailsReducer,
});
export default rootReducer;
